/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'
import Layout from '../components/Layout'
import ThemeWrapper from '../components/Theme'
import { ColumnCover, Column, Menu, ColumnWrapper, Subtitle, MenuWrap, MenuButton, MenuWrapBox, MenuButtonClose, Button, ColumnWrap, Title, Text, Image } from '@swp/components'


export default function Page(props) {
  return (
    <ThemeWrapper>
      <Layout title={"Fotogalerie"}>
        <ColumnCover name={"menu"}>
          
          <Column className="--menu --style4 pb--30 pl--40 pr--40 pt--30" menu={true}>
            
            <Menu className="--full pb--06 pl--06 pr--06 pt--06" style={{"maxWidth":""}} fullscreen={true}>
              
              <ColumnWrapper className="menu-logo-box">
                
                <Subtitle className="subtitle-box subtitle-box--invert" content={"23—6—2021"}>
                </Subtitle>

              </ColumnWrapper>

              <MenuWrap >
                
                <MenuButton >
                </MenuButton>

                <MenuWrapBox >
                  
                  <MenuButtonClose >
                  </MenuButtonClose>

                  <Button className="btn-box btn-box--hvr3 btn-box--sbtn2 btn-box--cColor2 fs--22 w--400 ls--004 pl--10 pr--10" innerClassName="pl--0 pr--0" href={"/"} target={""} content={"Místo a čas"}>
                  </Button>

                  <Button className="btn-box btn-box--hvr3 btn-box--sbtn2 btn-box--cColor2 fs--22 w--400 ls--004 pl--10 pr--10" innerClassName="pl--0 pr--0" href={"/svatebni-dary"} target={""} content={"Svatební dary"}>
                  </Button>

                  <Button className="btn-box btn-box--hvr3 btn-box--sbtn2 btn-box--cColor2 fs--22 w--400 ls--004 pl--10" innerClassName="pl--0 pr--0" href={"/potvrdit-ucast"} target={""} content={"Potvrdit účast"}>
                  </Button>

                </MenuWrapBox>

              </MenuWrap>

            </Menu>

          </Column>

        </ColumnCover>


        <Column className="pb--80 pt--80" name={"informace"} border={null} layout={"l13"}>
          
          <ColumnWrap className="column__flex --center el--1 pl--0 pr--0 flex--center" anim={null} animS={null} style={{"maxWidth":1080}} columns={"1"} fullscreen={false}>
            
            <ColumnWrapper style={{"maxWidth":""}}>
              
              <Title className="title-box title-box--center w--300 title-box--invert pt--50" content={"Fotogalerie"}>
              </Title>

              <Text className="text-box mt--10" content={"Fotky z našeho zásnubního focení."}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="--l8w pb--80 pt--20" name={"fotogalerie"} lightbox={true}>
          
          <ColumnWrap className="column__flex --center el--3 pb--40" columns={"3"}>
            
            <ColumnWrapper >
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/11212/3fba30cf38984f718634b332a5029b0b_s=860x_.jpeg"} svg={false} ratio={"4:3"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/11212/3fba30cf38984f718634b332a5029b0b_s=350x_.jpeg 350w, https://cdn.swbpg.com/t/11212/3fba30cf38984f718634b332a5029b0b_s=660x_.jpeg 660w, https://cdn.swbpg.com/t/11212/3fba30cf38984f718634b332a5029b0b_s=860x_.jpeg 860w, https://cdn.swbpg.com/t/11212/3fba30cf38984f718634b332a5029b0b_s=1400x_.jpeg 1400w, https://cdn.swbpg.com/t/11212/3fba30cf38984f718634b332a5029b0b_s=2000x_.jpeg 2000w"} content={null}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/11212/9a35d7c1514e4cfc9d89f2eb2667524b_s=860x_.jpeg"} svg={false} ratio={"4:3"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/11212/9a35d7c1514e4cfc9d89f2eb2667524b_s=350x_.jpeg 350w, https://cdn.swbpg.com/t/11212/9a35d7c1514e4cfc9d89f2eb2667524b_s=660x_.jpeg 660w, https://cdn.swbpg.com/t/11212/9a35d7c1514e4cfc9d89f2eb2667524b_s=860x_.jpeg 860w, https://cdn.swbpg.com/t/11212/9a35d7c1514e4cfc9d89f2eb2667524b_s=1400x_.jpeg 1400w, https://cdn.swbpg.com/t/11212/9a35d7c1514e4cfc9d89f2eb2667524b_s=2000x_.jpeg 2000w"} content={null}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/11212/d3350649fbd34703b92f148cf574a381_s=860x_.jpeg"} svg={false} ratio={"4:3"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/11212/d3350649fbd34703b92f148cf574a381_s=350x_.jpeg 350w, https://cdn.swbpg.com/t/11212/d3350649fbd34703b92f148cf574a381_s=660x_.jpeg 660w, https://cdn.swbpg.com/t/11212/d3350649fbd34703b92f148cf574a381_s=860x_.jpeg 860w, https://cdn.swbpg.com/t/11212/d3350649fbd34703b92f148cf574a381_s=1400x_.jpeg 1400w, https://cdn.swbpg.com/t/11212/d3350649fbd34703b92f148cf574a381_s=2000x_.jpeg 2000w"} content={null}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/11212/aaef05e0ab6d4082bb6774d5aa3e732c_s=860x_.jpeg"} svg={false} ratio={"4:3"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/11212/aaef05e0ab6d4082bb6774d5aa3e732c_s=350x_.jpeg 350w, https://cdn.swbpg.com/t/11212/aaef05e0ab6d4082bb6774d5aa3e732c_s=660x_.jpeg 660w, https://cdn.swbpg.com/t/11212/aaef05e0ab6d4082bb6774d5aa3e732c_s=860x_.jpeg 860w, https://cdn.swbpg.com/t/11212/aaef05e0ab6d4082bb6774d5aa3e732c_s=1400x_.jpeg 1400w, https://cdn.swbpg.com/t/11212/aaef05e0ab6d4082bb6774d5aa3e732c_s=2000x_.jpeg 2000w"} content={null}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=860x_.jpeg"} svg={false} ratio={"4:3"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=350x_.jpeg 350w, https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=660x_.jpeg 660w, https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=860x_.jpeg 860w, https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=1400x_.jpeg 1400w, https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=2000x_.jpeg 2000w"} content={null}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/11212/c9799baaee2045f1899a4aeb666642b7_s=860x_.jpeg"} svg={false} ratio={"4:3"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/11212/c9799baaee2045f1899a4aeb666642b7_s=350x_.jpeg 350w, https://cdn.swbpg.com/t/11212/c9799baaee2045f1899a4aeb666642b7_s=660x_.jpeg 660w, https://cdn.swbpg.com/t/11212/c9799baaee2045f1899a4aeb666642b7_s=860x_.jpeg 860w, https://cdn.swbpg.com/t/11212/c9799baaee2045f1899a4aeb666642b7_s=1400x_.jpeg 1400w, https://cdn.swbpg.com/t/11212/c9799baaee2045f1899a4aeb666642b7_s=2000x_.jpeg 2000w"} content={null}>
              </Image>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-c583e9 --center bg--bottom --parallax pb--80 pt--60" name={"paticka"} parallax={true} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=350x_.jpeg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=660x_.jpeg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=860x_.jpeg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=1400x_.jpeg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=2000x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=660x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=1400x_.jpeg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/11212/10556e3caf9246d09439451a659cf483_s=3000x_.jpeg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --center el--1" columns={"1"}>
            
            <ColumnWrapper className="--center pb--40 pt--40">
              
              <Title className="title-box" content={"Těšíme se na Vás!"}>
              </Title>

              <Subtitle className="subtitle-box mt--10" content={"23.6.2021"}>
              </Subtitle>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>

      </Layout>
    </ThemeWrapper>
  )
}